export default {
      id: "ic_send_comment-usage",
      viewBox: "0 0 22 18",
      url: "/" + "images/icons.3.109.2.svg#ic_send_comment-usage",
      toString: function () {
        return this.url;
      }
    }